import script from "./CardPieChart.vue?vue&type=script&setup=true&lang=js"
export * from "./CardPieChart.vue?vue&type=script&setup=true&lang=js"

import "./CardPieChart.vue?vue&type=style&index=0&id=2313d825&scoped=true&lang=css"

import exportComponent from "/Users/amsrafid/Projects/www/miaccounts-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2313d825"]])

export default __exports__